import(/* webpackMode: "eager", webpackExports: ["OcaSuspendedPage"] */ "/codebuild/output/src2528728641/src/apps/dfe/app/(protected)/OcaSuspendedPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Layout"] */ "/codebuild/output/src2528728641/src/packages/ui-dfe/components/src/lib/Layout/Layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DraftProtectionProvider"] */ "/codebuild/output/src2528728641/src/packages/ui-dfe/hooks/src/lib/config/useDraftProtection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider","default","useAuth"] */ "/codebuild/output/src2528728641/src/packages/ui-dfe/hooks/src/lib/useAuth/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PermissionProvider"] */ "/codebuild/output/src2528728641/src/packages/ui-permission/src/lib/hooks/PermissionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CloudWatchRumProvider"] */ "/codebuild/output/src2528728641/src/packages/ui-rum/src/lib/hooks/CloudWatchRumProvider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2528728641/src/packages/ui-typesense-client/src/lib/TypesenseProvider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2528728641/src/packages/ui-typesense-client/src/lib/useTypesenseSearch.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2528728641/src/packages/ui-typesense-client/src/lib/useTypesenseTotal.ts");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2528728641/src/packages/ui-typesense-client/src/lib/useUiTypesenseClient.ts");
